import { render, staticRenderFns } from "./imageViewerComponent.vue?vue&type=template&id=0c81f279&scoped=true&"
import script from "./imageViewerComponent.vue?vue&type=script&lang=js&"
export * from "./imageViewerComponent.vue?vue&type=script&lang=js&"
import style0 from "./imageViewerComponent.vue?vue&type=style&index=0&id=0c81f279&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c81f279",
  null
  
)

export default component.exports